import { useNavigate } from "react-router-dom";
import { ArrowRight, Plane, GraduationCap, Scale, Building2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Brand } from "./Shared";
import { BIZ_PERSONAS } from "../mock";
import { setPersona } from "../lib/persona";

const ICONS = { Plane, GraduationCap, Scale, Building2 };

export default function PersonaDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const pick = (id) => { setPersona(id); onOpenChange(false); navigate("/business"); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-card p-6 sm:p-8" data-testid="persona-dialog">
        <DialogTitle className="text-2xl sm:text-3xl font-semibold tracking-tight"><Brand /> for business. What do you run?</DialogTitle>
        <DialogDescription className="text-sm text-label2">The site, the workspace and the assistant orient to your business. You can change this any time.</DialogDescription>
        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          {BIZ_PERSONAS.map((p) => { const Icon = ICONS[p.icon]; return (
            <button key={p.id} type="button" onClick={() => pick(p.id)} data-testid={`persona-${p.id}`}
              className="group flex items-start gap-4 rounded-card border border-separator bg-background p-5 text-left transition-[border-color,box-shadow,transform] hover:-translate-y-0.5 hover:border-primary hover:shadow-pop">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary"><Icon className="h-5 w-5" strokeWidth={1.8} /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-semibold">{p.label}</span>
                <span className="mt-1 block text-xs text-label2"><Brand /> as your {p.role}</span>
              </span>
              <ArrowRight className="mt-1 h-4 w-4 shrink-0 text-label3 transition-transform group-hover:translate-x-1 group-hover:text-primary" />
            </button>
          ); })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
